mutation CreateMatchCampaignCategory(
  $matchCampaignCategoryInput: MatchCampaignCategoryInput!
) {
  createMatchCampaignCategory(
    input: { matchCampaignCategoryInput: $matchCampaignCategoryInput }
  ) {
    matchCampaignCategory {
      id
    }
  }
}
